import { memo, MouseEventHandler, ReactNode } from "react";
import { useClassNames } from "../../../shared/hooks";

import styles from "./styles.module.scss";

type ButtonType = {
  onClick?: MouseEventHandler<HTMLButtonElement>;
  isTransparent?: boolean;
  isBulky?: boolean;
  bigIcon?: boolean;
  isContainerWide?: boolean;
  isRounded?: boolean;
  noMargin?: boolean;
  noBackground?: boolean;
  iconPath?: string;
  iconFirst?: boolean;
  submit?: boolean;
  disabled?: boolean;
  children?: ReactNode;
  color?: string;
  backgroundColor?: string;
  isText?: boolean;
  isInline?: boolean;
  isLoading?: boolean;
};

const Button = ({
  onClick,
  isTransparent,
  isBulky,
  bigIcon,
  isRounded,
  noMargin,
  noBackground,
  iconFirst,
  isContainerWide,
  iconPath,
  submit,
  disabled,
  children,
  color,
  isText,
  isInline,
  isLoading,
  backgroundColor,
}: ButtonType) => {
  const classNames = useClassNames([
    styles.Button,
    isTransparent ? styles["Button--transparent"] : "",
    isBulky ? styles["Button--bulky"] : "",
    bigIcon ? styles["Button--bigIcon"] : "",
    isRounded ? styles["Button--pilled"] : "",
    noMargin ? styles["Button--noMargin"] : "",
    noBackground ? styles["Button--noBackground"] : "",
    !children ? styles["Button--noChild"] : "",
    iconFirst ? styles["Button--reverseOrder"] : "",
    isContainerWide ? styles["Button--wideContainer"] : "",
    isText ? styles["Button--text"] : "",
    isInline ? styles["Button--inline"] : "",
    isLoading ? styles["Button--loading"] : "",
  ]);

  return (
    <button
      type={submit ? "submit" : "button"}
      onClick={onClick}
      className={classNames}
      disabled={disabled}
      style={{
        color: color,
        backgroundColor,
        border: backgroundColor ? `1px solid ${backgroundColor}` : undefined,
      }}
    >
      <div className={styles["Button--container"]}>
        {children}
        {iconPath && <img src={iconPath} alt="" />}
      </div>
    </button>
  );
};

export default memo(Button);
